module.exports = __webpack_public_path__ + "img/Jiebo_Luo.ad2c0035.png";